/**
 * The payroll adjustment vocabulary, in ONE place.
 *
 * It previously existed as two shapes that named each other nowhere: the
 * `<option>` list inside `AdjustmentModal`, and `validTypes` in the API's
 * `POST /pay-periods/:id/adjustments`. A third consumer (the printed pay stub)
 * needed labels and had nothing to import, which is how a vocabulary acquires
 * its fourth copy.
 *
 * `Record<AdjustmentType, string>` is the point of the type: adding a value to
 * the union without a label is a compile error rather than a blank cell.
 */
export const ADJUSTMENT_TYPES = [
  'bonus',
  'deduction',
  'reimbursement',
  'stat_holiday',
  'overtime_correction',
  'other',
] as const;

export type AdjustmentType = (typeof ADJUSTMENT_TYPES)[number];

export const ADJUSTMENT_TYPE_LABELS: Record<AdjustmentType, string> = {
  bonus: 'Bonus',
  deduction: 'Deduction',
  reimbursement: 'Reimbursement',
  stat_holiday: 'Stat Holiday',
  overtime_correction: 'Overtime Correction',
  other: 'Other',
};

/** Tolerates an unknown string rather than rendering blank — the API's CHECK is the real gate. */
export function getAdjustmentLabel(type: string | undefined | null): string {
  if (!type) return '—';
  return ADJUSTMENT_TYPE_LABELS[type as AdjustmentType]
    ?? type.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
